import { StudentRegistry } from "@/features/student-registry";

export function StudentRegistryPage() {
  return <StudentRegistry />;
}
